export const menuOperational = [
  {
    id: 1,
    label: 'Dashboard',
    icon: 'bx bx-home',
    link: '/adm/opr/dashboard',
    name: 'dashboard',
    modul: 'operasional',
  },
  {
    id: 2,
    label: 'Principles',
    icon: 'bx bx-user-circle',
    link: '/adm/opr/principles',
    name: 'principle',
    modul: 'operasional',
  },
  {
    id: 3,
    label: 'Customers',
    icon: 'bx bx-user',
    link: '/adm/opr/customers',
    name: 'customer',
    modul: 'operasional',
  },
  {
    id: 4,
    label: 'Document',
    icon: 'bx bx-paste',
    link: '/adm/opr/doc/',
    subItems: [
      {
        id: 41,
        label: 'Container In',
        link: '/adm/opr/doc/interchange',
        name: 'docInterchange',
        modul: 'operasional',
        parentId: 4,
      },
      {
        id: 42,
        label: 'Checking',
        link: '/adm/opr/doc/checking',
        name: 'docChecking',
        modul: 'operasional',
        parentId: 4,
      },
      {
        id: 43,
        label: 'Container Out',
        link: '/adm/opr/doc/booking',
        name: 'docBooking',
        modul: 'operasional',
        parentId: 4,
      },
    ],
  },
  {
    id: 5,
    label: 'Data Check',
    icon: 'bx bx-check-circle',
    link: '/adm/opr/check/',
    subItems: [
      {
        id: 51,
        label: 'Check In',
        link: '/adm/opr/check/in',
        name: 'dataCheckIn',
        modul: 'operasional',
        parentId: 4,
      },
      {
        id: 52,
        label: 'Check Out',
        link: '/adm/opr/check/out',
        name: 'dataCheckOut',
        modul: 'operasional',
        parentId: 4,
      },
    ],
  },
  {
    id: 7,
    label: 'Booking Truck',
    icon: 'bx bx-bus',
    link: '/adm/opr/truck',
    subItems: [
      {
        id: 71,
        label: 'Vendor Trucking',
        link: '/adm/opr/truck/vendor',
        name: 'TruckVendor',
        modul: 'operasional',
        parentId: 7,
      },
      {
        id: 72,
        label: 'Container In',
        link: '/adm/opr/truck/interchange',
        name: 'TruckInterchange',
        modul: 'operasional',
        parentId: 7,
      },
      {
        id: 73,
        label: 'Container Out',
        link: '/adm/opr/truck/booking',
        name: 'TruckBooking',
        modul: 'operasional',
        parentId: 7,
      },
    ],
  },
  {
    id: 5,
    label: 'Payment',
    icon: 'bx bx-money',
    link: '/adm/opr/payment',
    subItems: [
      {
        id: 41,
        label: 'Interchange',
        link: '/adm/opr/payment/interchange',
        name: 'paymentInterchange',
        modul: 'operasional',
        parentId: 4,
      },
      {
        id: 42,
        label: 'Booking',
        link: '/adm/opr/payment/booking',
        name: 'paymentBooking',
        modul: 'operasional',
        parentId: 4,
      },
      {
        id: 43,
        label: 'Repair',
        link: '/adm/opr/payment/repair',
        name: 'paymentRepair',
        modul: 'operasional',
        parentId: 4,
      },
      {
        id: 44,
        label: 'Seal',
        link: '/adm/opr/payment/seal',
        name: 'paymentSeal',
        modul: 'operasional',
        parentId: 4,
      },
    ],
  },
  {
    id: 6,
    label: 'Survey',
    link: '/adm/opr/survey',
    icon: 'bx bx-food-menu',
    subItems: [
      {
        id: 61,
        label: 'Part of Survey',
        link: '/adm/opr/survey/part-of-survey',
        name: 'surveyPartOfSurvey',
        modul: 'operasional',
        parentId: 6,
      },
      {
        id: 62,
        label: 'Survey In',
        link: '/adm/opr/survey/container-in',
        name: 'surveyIn',
        modul: 'operasional',
        parentId: 6,
      },
      {
        id: 63,
        label: 'Survey Out',
        link: '/adm/opr/survey/container-out',
        name: 'surveyOut',
        modul: 'operasional',
        parentId: 6,
      },
      // {
      //   id: 64,
      //   label: 'NAT Container',
      //   link: '/adm/opr/survey/nat-container',
      //   parentId: 7,
      // },
    ],
  },
  {
    id: 8,
    label: 'Crani',
    icon: 'bx bx-archive',
    link: '/adm/opr/crani',
    subItems: [
      {
        id: 81,
        label: 'Crani In',
        link: '/adm/opr/crani/container-in',
        name: 'craniIn',
        modul: 'operasional',
        parentId: 8,
      },
      {
        id: 82,
        label: 'Crani Out',
        link: '/adm/opr/crani/container-out',
        name: 'craniOut',
        modul: 'operasional',
        parentId: 8,
      },
    ],
  },
  {
    id: 8,
    label: 'EIR',
    icon: 'bx bx-book-content',
    link: '/adm/opr/eir',
    subItems: [
      {
        id: 81,
        label: 'Container In',
        link: '/adm/opr/eir/container-in',
        name: 'eirIn',
        modul: 'operasional',
        parentId: 8,
      },
      {
        id: 82,
        label: 'Container Out',
        link: '/adm/opr/eir/container-out',
        name: 'eirOut',
        modul: 'operasional',
        parentId: 8,
      },
      {
        id: 83,
        label: 'Document Taken',
        link: '/adm/opr/eir/document-taken',
        name: 'eirDocTaken',
        modul: 'operasional',
        parentId: 8,
      },
    ],
  },
  {
    id: 9,
    label: 'PTI',
    link: '/adm/opr/pti',
    icon: 'bx bx-collection',
    subItems: [
      {
        id: 91,
        label: 'Survey',
        link: '/adm/opr/pti/survey',
        name: 'ptiSurvey',
        modul: 'operasional',
        parentId: 9,
      },
      {
        id: 92,
        label: 'Estimate Cost',
        link: '/adm/opr/pti/estimate-cost',
        name: 'ptiEstimateCost',
        modul: 'operasional',
        parentId: 9,
      },
      {
        id: 93,
        label: 'Work Order',
        link: '/adm/opr/pti/work-order',
        name: 'ptiWorkOrder',
        modul: 'operasional',
        parentId: 9,
      },
      {
        id: 94,
        label: 'Repair Container',
        link: '/adm/opr/pti/repair-container',
        name: 'ptiRepairContainer',
        modul: 'operasional',
        parentId: 9,
      },
      {
        id: 94,
        label: 'Quality Control',
        link: '/adm/opr/pti/quality-control',
        name: 'ptiQualityControl',
        modul: 'operasional',
        parentId: 9,
      },
    ],
  },
  {
    id: 10,
    label: 'EOR',
    link: '/adm/opr/eor',
    icon: 'bx bx-edit-alt',
    subItems: [
      {
        id: 101,
        label: 'Vendor Repair',
        link: '/adm/opr/eor/vendor-repair',
        name: 'eorVendorRepair',
        modul: 'operasional',
        parentId: 10,
      },
      {
        id: 102,
        label: 'Estimate Cost',
        link: '/adm/opr/eor/estimate-cost',
        name: 'eorEstimateCost',
        modul: 'operasional',
        parentId: 10,
      },
      {
        id: 103,
        label: 'Work Order',
        link: '/adm/opr/eor/work-order',
        name: 'eorWorkOrder',
        modul: 'operasional',
        parentId: 10,
      },
      {
        id: 104,
        label: 'Repair Container',
        link: '/adm/opr/eor/repair-container',
        name: 'eorRepairContainer',
        modul: 'operasional',
        parentId: 10,
      },
      {
        id: 105,
        label: 'Quality Control',
        link: '/adm/opr/eor/quality-control',
        name: 'eorQualityControl',
        modul: 'operasional',
        parentId: 10,
      },
      {
        id: 106,
        label: 'Upgrade Repair',
        link: '/adm/opr/eor/repeat-repair',
        name: 'repeatRepair',
        modul: 'operasional',
        parentId: 10,
      },
    ],
  },
  {
    id: 12,
    label: 'Container',
    link: '/adm/opr/container',
    icon: 'bx bx-cuboid',
    subItems: [
      {
        id: 124,
        label: 'Back to Stock',
        link: '/adm/opr/container/back-to-stock',
        name: 'backToStock',
        modul: 'operasional',
        parentId: 12,
      },
      {
        id: 125,
        label: 'Block Container',
        link: '/adm/opr/container/block-container',
        name: 'blockContainer',
        modul: 'operasional',
        parentId: 12,
      },
      {
        id: 126,
        label: 'Block Document',
        link: '/adm/opr/container/block-document',
        name: 'blockDocument',
        modul: 'operasional',
        parentId: 12,
      },
      // {
      //   id: 125,
      //   label: 'Hold Repair',
      //   link: '/adm/opr/container/hold-repair',
      //   name: 'holdRepair',
      //   modul: 'operasional',
      //   parentId: 12,
      // },
      {
        id: 120,
        label: 'Condition',
        link: '/adm/opr/container/condition',
        name: 'contCondition',
        modul: 'operasional',
        parentId: 12,
      },
      {
        id: 121,
        label: 'Information',
        link: '/adm/opr/container/information',
        name: 'contInformation',
        modul: 'operasional',
        parentId: 12,
      },
      {
        id: 122,
        label: 'Location',
        link: '/adm/opr/container/location',
        name: 'contLocation',
        modul: 'operasional',
        parentId: 12,
      },
      {
        id: 123,
        label: 'Photos',
        link: '/adm/opr/container/photos',
        name: 'contPhoto',
        modul: 'operasional',
        parentId: 12,
      },
      {
        id: 124,
        label: 'Cleaning',
        link: '/adm/opr/container/cleaning',
        name: 'contCleaning',
        modul: 'operasional',
        parentId: 12,
      },
    ],
  },
  {
    id: 12,
    label: 'Seal',
    link: '/adm/opr/seal',
    icon: 'bx bx-lock-open-alt',
    subItems: [
      {
        id: 121,
        label: 'Daftar Seal',
        link: '/adm/opr/seal',
        name: 'seal',
        modul: 'operasional',
        parentId: 12,
      },
      {
        id: 122,
        label: 'Share Seal',
        link: '/adm/opr/share-seal',
        name: 'shareSeal',
        modul: 'operasional',
        parentId: 12,
      },
    ],
  },
  {
    id: 13,
    label: 'Transaksi',
    link: '/adm/opr/transaksi',
    icon: 'bx bx-receipt',
    subItems: [
      {
        id: 130,
        label: 'Document Fee In',
        link: '/adm/opr/transaksi/document-fee-in',
        name: 'transDocumentFeeIn',
        modul: 'operasional',
        parentId: 13,
      },
      {
        id: 130,
        label: 'Document Fee Out',
        link: '/adm/opr/transaksi/document-fee-out',
        name: 'transDocumentFeeOut',
        modul: 'operasional',
        parentId: 13,
      },
      {
        id: 131,
        label: 'Other In',
        link: '/adm/opr/transaksi/other-in',
        name: 'transOtherIn',
        modul: 'operasional',
        parentId: 13,
      },
      {
        id: 131,
        label: 'Other Out',
        link: '/adm/opr/transaksi/other-out',
        name: 'transOtherOut',
        modul: 'operasional',
        parentId: 13,
      },
      {
        id: 131,
        label: 'Storage',
        link: '/adm/opr/transaksi/storage',
        name: 'transStorage',
        modul: 'operasional',
        parentId: 13,
      },
      {
        id: 132,
        label: 'Lift Off',
        link: '/adm/opr/transaksi/lift-off',
        name: 'transLiftOff',
        modul: 'operasional',
        parentId: 13,
      },
      {
        id: 133,
        label: 'Lift On',
        link: '/adm/opr/transaksi/lift-on',
        name: 'transLiftOn',
        modul: 'operasional',
        parentId: 13,
      },
      {
        id: 134,
        label: 'Cleaning',
        link: '/adm/opr/transaksi/cleaning',
        name: 'transCleaning',
        modul: 'operasional',
        parentId: 13,
      },
      {
        id: 135,
        label: 'Truck Interchange',
        link: '/adm/opr/transaksi/truck-interchange',
        name: 'transTruckInterchange',
        modul: 'operasional',
        parentId: 13,
      },
      {
        id: 135,
        label: 'Truck Booking',
        link: '/adm/opr/transaksi/truck-booking',
        name: 'transTruckBooking',
        modul: 'operasional',
        parentId: 13,
      },
      {
        id: 136,
        label: 'EOR',
        link: '/adm/opr/transaksi/eor',
        name: 'transEor',
        modul: 'operasional',
        parentId: 13,
      },
      {
        id: 137,
        label: 'PTI',
        link: '/adm/opr/transaksi/pti',
        name: 'transPti',
        modul: 'operasional',
        parentId: 13,
      },
    ],
  },
  // {
  //   id: 14,
  //   label: 'Daily Report',
  //   link: '/adm/opr/daily-report',
  //   icon: 'bx bx-printer',
  //   subItems: [
  //     {
  //       id: 140,
  //       label: 'History',
  //       link: '/adm/opr/daily-report/history',
  //       name: 'dailyReportHistory',
  //       modul: 'operasional',
  //       parentId: 14,
  //     },
  //   ],
  // },
  {
    id: 15,
    label: 'Report',
    link: '/adm/opr/report',
    icon: 'bx bx-printer',
    subItems: [
      {
        id: 148,
        label: 'Daily Report Check',
        link: '/adm/opr/report/daily-check',
        name: 'reportDailyCheck',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 149,
        label: 'Daily Report',
        link: '/adm/opr/report/daily',
        name: 'reportDaily',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 149,
        label: 'EDI Daily Report',
        link: '/adm/opr/report/edi-daily',
        name: 'reportEDIDaily',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 150,
        label: 'Report Cashier',
        link: '/adm/opr/report/cashier',
        name: 'reportCashier',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 150,
        label: 'Monthly Cashier',
        link: '/adm/opr/report/monthly-cashier',
        name: 'reportMonthlyCashier',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 151,
        label: 'Report Seal',
        link: '/adm/opr/report/seal',
        name: 'reportSeal',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 151,
        label: 'Container In',
        link: '/adm/opr/report/container-in',
        name: 'reportContIn',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 152,
        label: 'Container Out',
        link: '/adm/opr/report/container-out',
        name: 'reportContOut',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 153,
        label: 'Stok Container',
        link: '/adm/opr/report/stok-container',
        name: 'reportStockContainer',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 153,
        label: 'Container Teus',
        link: '/adm/opr/report/teus',
        name: 'reportTeusContainer',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 154,
        label: 'Survey In',
        link: '/adm/opr/report/survey-in',
        name: 'reportSurveyIn',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 154,
        label: 'Survey Out',
        link: '/adm/opr/report/survey-out',
        name: 'reportSurveyOut',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 155,
        label: 'EOR Container',
        link: '/adm/opr/report/eor-container',
        name: 'reportEorContainer',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 156,
        label: 'EOR Repair',
        link: '/adm/opr/report/repair-eor',
        name: 'reportEorRepair',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 156,
        label: 'EOR Upgrade Repair',
        link: '/adm/opr/report/repeat-repair-eor',
        name: 'reportEorRepeat',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 157,
        label: 'PTI Container',
        link: '/adm/opr/report/pti-container',
        name: 'reportPtiContainer',
        modul: 'operasional',
        parentId: 15,
      },
      {
        id: 158,
        label: 'PTI Repair',
        link: '/adm/opr/report/repair-pti',
        name: 'reportPtiRepair',
        modul: 'operasional',
        parentId: 15,
      },
    ],
  },
  // {
  //   id: 14,
  //   label: 'Special Report',
  //   link: '/adm/opr/special-report',
  //   icon: 'bx bx-pie-chart-alt-2',
  //   subItems: [
  //     {
  //       id: 141,
  //       label: 'Standart',
  //       link: '/adm/opr/special-report/standart',
  //       parentId: 14,
  //     },
  //     {
  //       id: 141,
  //       label: 'APL',
  //       link: '/adm/opr/special-report/apl',
  //       parentId: 14,
  //     },
  //     {
  //       id: 142,
  //       label: 'CMA',
  //       link: '/adm/opr/special-report/cma',
  //       parentId: 14,
  //     },
  //     {
  //       id: 143,
  //       label: 'YML',
  //       link: '/adm/opr/special-report/yml',
  //       parentId: 14,
  //     },
  //     {
  //       id: 144,
  //       label: 'WHL (ECS)',
  //       link: '/adm/opr/special-report/whl',
  //       parentId: 14,
  //     },
  //     {
  //       id: 145,
  //       label: 'SCL',
  //       link: '/adm/opr/special-report/scl',
  //       parentId: 14,
  //     },
  //     {
  //       id: 146,
  //       label: 'SIT',
  //       link: '/adm/opr/special-report/sit',
  //       parentId: 14,
  //     },
  //     {
  //       id: 147,
  //       label: 'DKM',
  //       link: '/adm/opr/special-report/dkm',
  //       parentId: 14,
  //     },
  //   ],
  // },
];

export const menuLogistic = [
  {
    id: 1,
    label: 'Dashboard',
    icon: 'bx bx-home',
    link: '/adm/logistic/dashboard',
    name: 'dashboardLogistic',
    modul: 'logistic',
  },
  {
    id: 2,
    label: 'Data Master',
    link: '/adm/logistic/master',
    icon: 'bx bx-archive-in',
    subItems: [
      {
        id: 21,
        label: 'Supplier',
        link: '/adm/logistic/master/supplier',
        name: 'masterSupplier',
        modul: 'logistic',
        parentId: 2,
      },
      {
        id: 22,
        label: 'Alat Berat',
        link: '/adm/logistic/master/alat-berat',
        name: 'masterAlatBerat',
        modul: 'logistic',
        parentId: 2,
      },
      {
        id: 23,
        label: 'Gudang',
        link: '/adm/logistic/master/gudang',
        name: 'masterGudang',
        modul: 'logistic',
        parentId: 2,
      },
      {
        id: 24,
        label: 'Kelompok Produk',
        link: '/adm/logistic/master/kelompok-product',
        name: 'masterKelProduk',
        modul: 'logistic',
        parentId: 2,
      },
      {
        id: 24,
        label: 'Satuan',
        link: '/adm/logistic/master/satuan',
        name: 'masterSatuan',
        modul: 'logistic',
        parentId: 2,
      },
      {
        id: 25,
        label: 'Produk',
        link: '/adm/logistic/master/product',
        name: 'logisticMasterProduk',
        modul: 'logistic',
        parentId: 2,
      },
    ],
  },
  {
    id: 3,
    label: 'Saldo Persediaan',
    link: '/adm/logistic/saldo-persediaan',
    icon: 'bx bxs-cog',
    name: 'saldoPersediaan',
    modul: 'logistic',
  },
  {
    id: 3,
    label: 'Pembelian',
    link: '/adm/logistic/pembelian',
    icon: 'bx bx-basket',
    subItems: [
      {
        id: 31,
        label: 'Order Pembelian',
        link: '/adm/logistic/pembelian/order-pembelian',
        name: 'pembelianOrder',
        modul: 'logistic',
        parentId: 3,
      },
      {
        id: 32,
        label: 'Retur Pembelian',
        link: '/adm/logistic/pembelian/retur-pembelian',
        name: 'logisticPembelianRetur',
        modul: 'logistic',
        parentId: 3,
      },
    ],
  },
  {
    id: 4,
    label: 'Penjualan',
    link: '/adm/logistic/penjualan',
    icon: 'bx bx-paste',
    subItems: [
      {
        id: 31,
        label: 'Order Penjualan',
        link: '/adm/logistic/penjualan/order-penjualan',
        name: 'penjualanOrder',
        modul: 'logistic',
        parentId: 3,
      },
      {
        id: 32,
        label: 'Retur Penjualan',
        link: '/adm/logistic/penjualan/retur-penjualan',
        name: 'logisticPenjualanRetur',
        modul: 'logistic',
        parentId: 3,
      },
    ],
  },
  // {
  //   id: 5,
  //   label: 'Stok Keluar',
  //   link: '/adm/logistic/stok/stok-keluar',
  //   icon: 'bx bx-file',
  //   name: 'stokKeluar',
  //   modul: 'logistic',
  // },
  {
    id: 6,
    label: 'Penyesuaian Stok',
    link: '/adm/logistic/stok/penyesuaian-stok',
    icon: 'bx bx-file',
    name: 'penyesuaianStok',
    modul: 'logistic',
  },
  {
    id: 11,
    label: 'Laporan',
    link: '/adm/logistic/laporan',
    icon: 'bx bx-printer',
    subItems: [
      {
        id: 91,
        label: 'Kartu Stok',
        link: '/adm/logistic/laporan/kartu-stok',
        name: 'lapKartuStok',
        modul: 'logistic',
        parentId: 9,
      },
      {
        id: 92,
        label: 'Pemakaian Alat',
        link: '/adm/logistic/laporan/pemakaian-alat',
        name: 'lapPemakaianAlat',
        modul: 'logistic',
        parentId: 9,
      },
      {
        id: 93,
        label: 'Order Pembelian',
        link: '/adm/logistic/laporan/order-pembelian',
        name: 'lapOrderPembelian',
        modul: 'logistic',
        parentId: 9,
      },
      {
        id: 94,
        label: 'Order Penjualan',
        link: '/adm/logistic/laporan/order-penjualan',
        name: 'lapOrderPenjualan',
        modul: 'logistic',
        parentId: 9,
      },
    ],
  },
];

export const menuFinance = [
  {
    id: 1,
    label: 'Dashboard',
    icon: 'bx bx-home',
    link: '/adm/fin/dashboard',
    name: 'dashboardFinance',
    modul: 'finance',
  },
  {
    id: 2,
    label: 'Master Data',
    icon: 'bx bx-archive-in',
    subItems: [
      {
        id: 21,
        label: 'Rekening Perkiraan',
        link: '/adm/fin/master/rekening-perkiraan',
        name: 'masterRekeningPerkiraan',
        modul: 'finance',
        parentId: 2,
      },
      {
        id: 22,
        label: 'Klasifikasi Akun',
        link: '/adm/fin/master/klasifikasi-akun',
        name: 'masterKlasifikasiAkun',
        modul: 'finance',
        parentId: 2,
      },
      {
        id: 23,
        label: 'Akun Penting',
        link: '/adm/fin/master/akun-penting',
        name: 'masterAkunPenting',
        modul: 'finance',
        parentId: 2,
      },
      {
        id: 24,
        label: 'Mata Uang',
        link: '/adm/fin/master/mata-uang',
        name: 'masterMataUang',
        modul: 'finance',
        parentId: 2,
      },
      // {
      //   id: 25,
      //   label: 'Proyek',
      //   link: '/adm/fin/master/proyek',
      //   parentId: 2,
      // },
      {
        id: 25,
        label: 'Pajak',
        link: '/adm/fin/master/pajak',
        name: 'masterPajak',
        modul: 'finance',
        parentId: 2,
      },
      {
        id: 26,
        label: 'Department',
        link: '/adm/fin/master/department',
        name: 'masterDepartment',
        modul: 'finance',
        parentId: 2,
      },
      {
        id: 27,
        label: 'Produk',
        link: '/adm/fin/master/produk',
        name: 'financeMasterProduk',
        modul: 'finance',
        parentId: 2,
      },
      {
        id: 29,
        label: 'Kelompok Harta',
        link: '/adm/fin/master/kelompok-harta',
        name: 'masterKelompokHarta',
        modul: 'finance',
        parentId: 2,
      },
      {
        id: 30,
        label: 'Harta Tetap',
        link: '/adm/fin/master/harta-tetap',
        name: 'masterHartaTetap',
        modul: 'finance',
        parentId: 2,
      },
    ],
  },
  {
    id: 3,
    label: 'Saldo Awal',
    link: '/adm/fin/saldo',
    icon: 'bx bxs-cog',
    subItems: [
      {
        id: 31,
        label: 'Saldo Awal Piutang',
        link: '/adm/fin/saldo/saldo-piutang',
        name: 'saldoAwalPiutang',
        modul: 'finance',
        parentId: 3,
      },
      {
        id: 32,
        label: 'Saldo Awal Hutang',
        link: '/adm/fin/saldo/saldo-hutang',
        name: 'saldoAwalHutang',
        modul: 'finance',
        parentId: 3,
      },
      {
        id: 33,
        label: 'Saldo Awal Akun',
        link: '/adm/fin/saldo/saldo-awal',
        name: 'saldoAwalSaldo',
        modul: 'finance',
        parentId: 3,
      },
    ],
  },
  {
    id: 4,
    label: 'Buku Besar',
    link: '/adm/fin/buku-besar',
    icon: 'bx bx-file',
    subItems: [
      {
        id: 41,
        label: 'Buku Besar',
        link: '/adm/fin/buku-besar/buku-besar',
        name: 'bukuBesar',
        modul: 'finance',
        parentId: 4,
      },
      {
        id: 42,
        label: 'Jurnal Umum',
        link: '/adm/fin/buku-besar/journal',
        name: 'jurnalUmum',
        modul: 'finance',
        parentId: 4,
      },
    ],
  },
  {
    id: 5,
    label: 'Penjualan',
    icon: 'bx bx-paste',
    link: '/adm/fin/penjualan',
    subItems: [
      {
        id: 51,
        label: 'Invoice Depo Tunai',
        link: '/adm/fin/penjualan/depo-cash',
        name: 'penjualanInvDepoTunai',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 52,
        label: 'Invoice Depo Kredit',
        link: '/adm/fin/penjualan/depo-credit',
        name: 'penjualanInvDepoKredit',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 53,
        label: 'Invoice Penjualan',
        link: '/adm/fin/penjualan/invoice-penjualan',
        name: 'penjualanInv',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 52,
        label: 'Piutang usaha',
        link: '/adm/fin/penjualan/piutang-usaha',
        name: 'penjualanPiutang',
        modul: 'finance',
        parentId: 4,
      },
      {
        id: 53,
        label: 'Pembayaran Piutang Usaha',
        link: '/adm/fin/penjualan/pembayaran-piutang-usaha',
        name: 'penjualanBayarPiutang',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 54,
        label: 'Uang Muka Penjualan',
        link: '/adm/fin/penjualan/uang-muka-penjualan',
        name: 'penjualanUangMuka',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 55,
        label: 'Retur Penjualan',
        link: '/adm/fin/penjualan/retur-penjualan',
        name: 'financePenjualanRetur',
        modul: 'finance',
        parentId: 5,
      },
      // {
      //   id: 55,
      //   label: 'Pengembalian Kelebihan (Kredit)',
      //   link: '/adm/fin/penjualan/pengembalian-kelebihan-kredit',
      //   parentId: 5,
      // },
    ],
  },

  {
    id: 5,
    label: 'Penjualan Detail',
    link: '/adm/fin/penjualan-lain',
    icon: 'bx bx-receipt',
    subItems: [
      {
        id: 47,
        label: 'Document Fee In',
        link: '/adm/fin/penjualan-lain/document-fee-in',
        name: 'transDocumentFeeIn',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 48,
        label: 'Document Fee Out',
        link: '/adm/fin/penjualan-lain/document-fee-out',
        name: 'transDocumentFeeOut',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 49,
        label: 'Other In',
        link: '/adm/fin/penjualan-lain/other-in',
        name: 'transOtherIn',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 50,
        label: 'Other Out',
        link: '/adm/fin/penjualan-lain/other-out',
        name: 'transOtherOut',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 51,
        label: 'Storage',
        link: '/adm/fin/penjualan-lain/storage',
        name: 'transStorage',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 52,
        label: 'Lift Off',
        link: '/adm/fin/penjualan-lain/lift-off',
        name: 'transLiftOff',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 53,
        label: 'Lift On',
        link: '/adm/fin/penjualan-lain/lift-on',
        name: 'transLiftOn',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 54,
        label: 'Cleaning',
        link: '/adm/fin/penjualan-lain/cleaning',
        name: 'transCleaning',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 55,
        label: 'Truck Interchange',
        link: '/adm/fin/penjualan-lain/truck-interchange',
        name: 'transTruckInterchange',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 55,
        label: 'Truck Booking',
        link: '/adm/fin/penjualan-lain/truck-booking',
        name: 'transTruckBooking',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 56,
        label: 'EOR',
        link: '/adm/fin/penjualan-lain/eor',
        name: 'transEor',
        modul: 'finance',
        parentId: 5,
      },
      {
        id: 57,
        label: 'PTI',
        link: '/adm/fin/penjualan-lain/pti',
        name: 'transPti',
        modul: 'finance',
        parentId: 5,
      },
    ],
  },
  {
    id: 6,
    label: 'Pembelian',
    icon: 'bx bx-basket',
    link: '/adm/fin/pembelian',
    subItems: [
      {
        id: 61,
        label: 'Invoice Pembelian',
        link: '/adm/fin/pembelian/invoice-pembelian',
        name: 'pembelianInvoice',
        modul: 'finance',
        parentId: 6,
      },
      {
        id: 62,
        label: 'Hutang Usaha',
        link: '/adm/fin/pembelian/hutang-usaha',
        name: 'pembelianHutang',
        modul: 'finance',
        parentId: 6,
      },
      {
        id: 63,
        label: 'Pembayaran Hutang',
        link: '/adm/fin/pembelian/pembayaran-hutang-usaha',
        name: 'pembelianBayarHutang',
        modul: 'finance',
        parentId: 6,
      },
      {
        id: 64,
        label: 'Uang Muka Beli',
        link: '/adm/fin/pembelian/uang-muka-pembelian',
        name: 'pembelianUangMuka',
        modul: 'finance',
        parentId: 6,
      },
      {
        id: 65,
        label: 'Retur Pembelian',
        link: '/adm/fin/pembelian/retur-pembelian',
        name: 'financePembelianRetur',
        modul: 'finance',
        parentId: 6,
      },
      // {
      //   id: 66,
      //   label: 'Penerimaan Kembalian',
      //   link: '/adm/fin/pembelian/penerimaan-kembalian-debit',
      //   parentId: 6,
      // },
    ],
  },
  {
    id: 7,
    label: 'Kas & Bank',
    icon: 'bx bx-copy-alt',
    link: '/adm/fin/kas-bank',
    subItems: [
      {
        id: 71,
        label: 'Kas Masuk',
        link: '/adm/fin/kas-bank/kas-masuk',
        name: 'kasMasuk',
        modul: 'finance',
        parentId: 7,
      },
      {
        id: 72,
        label: 'Kas Keluar',
        link: '/adm/fin/kas-bank/kas-keluar',
        name: 'kasKeluar',
        modul: 'finance',
        parentId: 7,
      },
      {
        id: 73,
        label: 'Transfer Kas',
        link: '/adm/fin/kas-bank/transfer-kas',
        name: 'kasTransfer',
        modul: 'finance',
        parentId: 7,
      },
      // {
      //   id: 74,
      //   label: 'Rekonsiliasi Bank',
      //   link: '/adm/fin/kas-bank/rekonsiliasi-bank',
      //   parentId: 7,
      // },
      {
        id: 75,
        label: 'Giro Masuk',
        link: '/adm/fin/kas-bank/giro-masuk',
        name: 'giroMasuk',
        modul: 'finance',
        parentId: 7,
      },
      {
        id: 76,
        label: 'Giro Keluar',
        link: '/adm/fin/kas-bank/giro-keluar',
        name: 'giroKeluar',
        modul: 'finance',
        parentId: 7,
      },
    ],
  },
  {
    id: 8,
    label: 'Faktur Pajak',
    icon: 'bx bx-copy-alt',
    link: '/adm/fin/faktur-pajak',
    subItems: [
      {
        id: 81,
        label: 'Master Faktur',
        link: '/adm/fin/faktur-pajak/setting-faktur',
        name: 'SettingFaktur',
        modul: 'finance',
        parentId: 8,
      },
      {
        id: 81,
        label: 'PDF File Faktur',
        link: '/adm/fin/faktur-pajak/file-faktur',
        name: 'FileFaktur',
        modul: 'finance',
        parentId: 8,
      },
      {
        id: 82,
        label: 'Generate Faktur',
        link: '/adm/fin/faktur-pajak/generate-faktur',
        name: 'GenerateFaktur',
        modul: 'finance',
        parentId: 8,
      },
      {
        id: 82,
        label: 'Laporan Faktur',
        link: '/adm/fin/faktur-pajak/laporan-faktur',
        name: 'LaporanFaktur',
        modul: 'finance',
        parentId: 8,
      },
    ],
  },
  {
    id: 9,
    label: 'Laporan',
    link: '/adm/fin/laporan',
    icon: 'bx bx-printer',
    subItems: [
      {
        id: 90,
        label: 'Lap Faktur Pajak',
        link: '/adm/fin/laporan/faktur-pajak',
        name: 'lapFakturPajak',
        modul: 'finance',
        parentId: 9,
      },
      {
        id: 91,
        label: 'Lap Laba Rugi',
        link: '/adm/fin/laporan/laba-rugi',
        name: 'lapLabaRugi',
        modul: 'finance',
        parentId: 9,
      },
      {
        id: 91,
        label: 'Lap Laba Rugi 12 Bulan',
        link: '/adm/fin/laporan/laba-rugi-setahun',
        name: 'lapLabaRugiSetahun',
        modul: 'finance',
        parentId: 9,
      },
      {
        id: 92,
        label: 'Laporan Neraca',
        link: '/adm/fin/laporan/neraca-saldo',
        name: 'lapNeraca',
        modul: 'finance',
        parentId: 9,
      },
      {
        id: 92,
        label: 'Laporan Arus Kas',
        link: '/adm/fin/laporan/arus-kas',
        name: 'lapArusKas',
        modul: 'finance',
        parentId: 9,
      },
      {
        id: 93,
        label: 'Laporan Buku Besar',
        link: '/adm/fin/laporan/buku-besar',
        name: 'lapBukuBesar',
        modul: 'finance',
        parentId: 9,
      },
      {
        id: 94,
        label: 'Laporan Jurnal',
        link: '/adm/fin/laporan/journal',
        name: 'lapJurnal',
        modul: 'finance',
        parentId: 9,
      },
      {
        id: 95,
        label: 'Laporan Kartu Piutang',
        link: '/adm/fin/laporan/kartu-piutang',
        name: 'lapKartuPiutang',
        modul: 'finance',
        parentId: 9,
      },
      {
        id: 96,
        label: 'Laporan Kartu Hutang',
        link: '/adm/fin/laporan/kartu-hutang',
        name: 'lapKartuHutang',
        modul: 'finance',
        parentId: 9,
      },
    ],
  },
  {
    id: 10,
    label: 'Tutup Buku',
    link: '/adm/fin/tutup-buku',
    icon: 'bx bx-exit',
    subItems: [
      {
        id: 101,
        label: 'Tutup Buku Bulanan',
        link: '/adm/fin/tutup-buku/bulanan',
        name: 'tutupBukuBulanan',
        modul: 'finance',
        parentId: 10,
      },
      {
        id: 101,
        label: 'Tutup Buku Tahunan',
        link: '/adm/fin/tutup-buku/tahunan',
        name: 'tutupBukuTahunan',
        modul: 'finance',
        parentId: 10,
      },
    ],
  },
];

export const menuSetting = [
  {
    id: 1,
    label: 'Dashboard',
    icon: 'bx bx-home',
    link: '/adm/conf/dashboard',
    name: 'dashboardSetting',
    modul: 'setting',
  },
  {
    id: 2,
    label: 'Users system',
    icon: 'bx bxs-user-detail',
    link: '/adm/conf/users',
    name: 'userSystem',
    modul: 'setting',
  },
  {
    id: 3,
    label: 'Principle Price',
    icon: 'bx bx-dollar-circle',
    link: '/adm/conf/principle-price',
    name: 'principlePrice',
    modul: 'setting',
  },
  {
    id: 4,
    label: 'Back Date Container',
    icon: 'bx bx-notepad',
    link: '/adm/conf/update-container-in',
    name: 'updateContainerIn',
    modul: 'setting',
  },
  {
    id: 5,
    label: 'Change Cont No',
    icon: 'bx bx-transfer-alt',
    link: '/adm/conf/change-container-no',
    name: 'changeContNo',
    modul: 'setting',
  },
  {
    id: 6,
    label: 'Exchange DO',
    icon: 'bx bx-transfer-alt',
    link: '/adm/conf/exchange-do',
    name: 'exchangeDO',
    modul: 'setting',
  },
  {
    id: 7,
    label: 'Pindah Stock Container',
    icon: 'bx bx-transfer-alt',
    link: '/adm/conf/pindah-stock',
    name: 'pindahStock',
    modul: 'setting',
  },
  {
    id: 6,
    label: 'Container Type',
    icon: 'bx bx-food-menu',
    link: '/adm/conf/container-type',
    name: 'containerType',
    modul: 'setting',
  },
  {
    id: 7,
    label: 'Company Info',
    icon: 'bx bxs-paste',
    link: '/adm/conf/company-info',
    name: 'companyInfo',
    modul: 'setting',
  },
  {
    id: 8,
    label: 'User Akses',
    icon: 'bx bx-lock-open',
    link: '/adm/conf/user-akses',
    name: 'userAkses',
    modul: 'setting',
  },
  {
    id: 9,
    label: 'Akun Jenis Pembayaran',
    icon: 'bx bx-wallet-alt',
    link: '/adm/conf/akun-jenis-pembayaran',
    name: 'akunJenisPembayaran',
    modul: 'setting',
  },
  {
    id: 10,
    label: 'Signature',
    icon: 'bx bx-check-square',
    link: '/adm/conf/signature',
    name: 'settingSignature',
    modul: 'setting',
  },
  // {
  //   id: 4,
  //   label: 'Block container',
  //   icon: 'bx bx-check-shield',
  //   link: '/adm/conf/block-container',
  //   subItems: [
  // {
  //   id: 41,
  //   label: 'Container',
  //   link: '/adm/conf/block-container/container',
  //   parentId: 4,
  // },
  //     {
  //       id: 42,
  //       label: 'Interchange',
  //       link: '/adm/conf/block-container/interchange',
  //       parentId: 4,
  //     },
  //     {
  //       id: 43,
  //       label: 'Booking',
  //       link: '/adm/conf/block-container/booking',
  //       parentId: 4,
  //     },
  //   ],
  // },
  // {
  //   id: 5,
  //   label: 'Tools',
  //   icon: 'bx bxs-cog',
  //   link: '/adm/conf/tools',
  //   subItems: [
  //     {
  //       id: 51,
  //       label: 'Back to stock',
  //       link: '/adm/conf/tools/back-stock',
  //       parentId: 5,
  //     },
  //     {
  //       id: 52,
  //       label: 'One way',
  //       link: '/adm/conf/tools/one-way',
  //       parentId: 5,
  //     },
  //     {
  //       id: 53,
  //       label: 'Admin tools',
  //       link: '/adm/conf/tools/admin-tools',
  //       parentId: 5,
  //     },
  //   ],
  // },
];

export default {
  menuOperational,
  menuLogistic,
  menuFinance,
  menuSetting,
};
